import { Box, Flex, RangeDateSelect, Text } from 'components'
import dayjs from 'dayjs'
import { useWorkspaceAnalytics } from './WorkspaceAnalyticsProvider'

export default function WorkspaceAnalyticsHeader() {
  return (
    <Flex direction="column" mb={3}>
      <Text textStyle="h3" pt={2}>
        Analytics
      </Text>

      <DateFilter />
    </Flex>
  )
}

function DateFilter() {
  const { dateRange, setDateRange } = useWorkspaceAnalytics()

  return (
    <Box alignSelf="flex-end">
      <RangeDateSelect
        buttonDisplayProps={{ placeholder: 'All time' }}
        defaults={[
          'this-week',
          'last-week',
          'this-month',
          'last-month',
          'this-quarter',
          'last-quarter',
          'this-year',
          'last-year',
        ]}
        menuProps={{
          menuProps: { positioning: { placement: 'bottom-end' } },
        }}
        selected={dateRange}
        onSelect={range => {
          if (!range?.from) return setDateRange(undefined)

          const { from, to } = range
          const _to = dayjs(to).add(1, 'day').subtract(1, 'millisecond').valueOf()
          setDateRange({ from, to: _to })
        }}
        timeZone="local"
      />
    </Box>
  )
}
